// extracted by mini-css-extract-plugin
export default {"venueCard":"_65iO9XnB6eKcm7OUvRNcJr"};